
import Http from "../helpers/Http";

class UserDataService {
  getAll() {
    return Http.get("/users/system");
  }

  get(id) {
    return Http.get(`/users/${id}`);
  }

  create(data) {
    return Http.post("/users", data);
  }

  update(data) {
    return Http.update("/users", data);
  }
  updateUserProfile(data) {
    return Http.update("/users/changeProfile", data);
  }

  login(data){
    return Http.post("/auth/login", data);
  }

  logOut() {
    localStorage.removeItem('user');
    this.$router.push('/login');
  }

  chagePassword(data) {
    return Http.update("/users/changePass", data);
  }

  updateUserInfo(data) {
    return Http.post("/users/update", data);
  }
  resetPassword(data){
    return Http.post("/users/restPwd",data)
  }
  
  validEmail(data){
    return Http.post("/users/exists",data);
  }

}

export default new UserDataService();